import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as FailedIcon } from "../../../assets/icons/failed.svg";
import { formatModelName } from "../../../utils/utils";
import {
  QWEN_Z_TWO_INPUT_IMAGES,
  VIDEO_RESOLUTION_TO_TIME,
} from "../../../utils/constants";
import {
  DotsSpan,
  FailedContent,
  FailedIconWrapper,
  FailedMessage,
  FailedModelName,
  FailedOverlay,
  FailedTitle,
  FreeMessageWrapper,
  LoadingImage,
  LoadingSpinnerBlur,
  ProgressCard,
  ProgressCore,
  ProgressRing,
  ProgressTrack,
  ProgressVisual,
  RetryButton,
  RunningMessage,
  RunningText,
  RunningTitle,
  UpgradeButton,
} from "./CollectionItem.styles";

export const useAnimatedDots = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev?.length < 3 ? prev + "." : ""));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return dots;
};

export const getBackgroundUrl = (video) =>
  QWEN_Z_TWO_INPUT_IMAGES === video?.modelType
    ? video?.input?.image?.url
    : video?.input?.image?.resizedImage?.url || video?.input?.image?.url;

const FreeContent = ({ mediaLabel }) => {
  const navigate = useNavigate();

  return (
    <FreeMessageWrapper>
      <RunningMessage>
        {mediaLabel} generation may take 4+ minutes on free tier. Upgrade for
        faster, higher-priority generation.
      </RunningMessage>
      <UpgradeButton
        $spacing={false}
        onClick={(e) => {
          e.stopPropagation();
          navigate("/subscription");
        }}
      >
        Upgrade
      </UpgradeButton>
    </FreeMessageWrapper>
  );
};

export const InProgressState = ({ video, isImage }) => {
  const animatedDots = useAnimatedDots();
  const mediaLabel = isImage ? "Image" : "Video";
  const estimatedTime = isImage
    ? "1-2"
    : (VIDEO_RESOLUTION_TO_TIME[video?.output?.resolution] ?? "3-5");

  return (
    <LoadingSpinnerBlur $show>
      <LoadingImage src={getBackgroundUrl(video)} />

      <ProgressCard>
        <ProgressVisual>
          <ProgressTrack />
          <ProgressRing />
          <ProgressCore>💦</ProgressCore>
        </ProgressVisual>
        <RunningText>
          <RunningTitle>
            <span>Generating</span>
            <DotsSpan>{animatedDots}</DotsSpan>
          </RunningTitle>

          {video?.isFree ? (
            <FreeContent mediaLabel={mediaLabel} />
          ) : (
            <RunningMessage>
              It may take {estimatedTime} minutes to generate the{" "}
              {mediaLabel.toLowerCase()}.
            </RunningMessage>
          )}
        </RunningText>
        {/* <ProgressBar /> */}
      </ProgressCard>
    </LoadingSpinnerBlur>
  );
};

export const FailedState = ({ video, isImage, retryLoading, onRetry }) => {
  return (
    <FailedOverlay>
      <LoadingImage src={getBackgroundUrl(video)} />

      <FailedContent>
        <FailedIconWrapper>
          <FailedIcon />
        </FailedIconWrapper>
        <FailedModelName>{formatModelName(video?.name)}</FailedModelName>
        <FailedTitle>Generation Failed</FailedTitle>
        <FailedMessage>
          {isImage ? "Image" : "Video"} generation failed.
          <br />
          Your drops have been refunded.
        </FailedMessage>
        <RetryButton onClick={onRetry} disabled={retryLoading}>
          {retryLoading ? (
            <l-bouncy size="14" stroke="2" speed="1" color="#fff" />
          ) : (
            "Retry"
          )}
        </RetryButton>
      </FailedContent>
    </FailedOverlay>
  );
};
